module.exports = "<div gw-claim-summary\r\n     policy-number=\"{{policyNumber}}\"\r\n     policy-type=\"{{product.publicID}}\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/views/policy/policy-claims.html
// module id = 813
// module chunks = 0